import { NgModule } from '@angular/core';
import { NgLet } from './ng-let';

@NgModule({
  declarations: [NgLet],
  exports: [NgLet],
})
export class ContribNgLetModule {}
